module.exports = __webpack_public_path__ + "media/icons/osoba-prywatna-active-621e4cab.png";